import React from 'react';
import useBreakpoint from '@/shared/hooks/useBreakpoint';

import {
  IntroContentContainer,
  IntroText,
  Container,
  Title,
} from '@/components/messages/styledComponents';
import MessageInbox from '@/components/messages/MessageInbox';
import { useIsMessagesChannel } from '@/shared/hooks/useIsMessagesChannel';
import BackButton from '@/shared/components/BackButton';
import { green } from '@/shared/styles/colors';

export default function MessagesLayoutWeb() {
  const { isDesktop } = useBreakpoint();
  const isInChat = useIsMessagesChannel();

  return (
    <Container isDesktop={isDesktop} isInChat={isInChat}>
      {isDesktop && (
        <BackButton tintColor={green} containerStyle={{ marginBottom: 12 }} />
      )}
      {!isInChat && (
        <IntroContentContainer isDesktop={isDesktop}>
          {!isDesktop && <Title>Messages</Title>}
          <IntroText isDesktop={isDesktop}>
            Keep the conversation going! Select to view.
          </IntroText>
        </IntroContentContainer>
      )}
      <MessageInbox />
    </Container>
  );
}
